import { render, staticRenderFns } from "./PlanilhaTrocaServico.vue?vue&type=template&id=12d08394&scoped=true"
import script from "./PlanilhaTrocaServico.vue?vue&type=script&lang=js"
export * from "./PlanilhaTrocaServico.vue?vue&type=script&lang=js"
import style0 from "./PlanilhaTrocaServico.vue?vue&type=style&index=0&id=12d08394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d08394",
  null
  
)

export default component.exports